import { render, staticRenderFns } from "./NetworkCard.vue?vue&type=template&id=655b806c&scoped=true&"
import script from "./NetworkCard.vue?vue&type=script&lang=js&"
export * from "./NetworkCard.vue?vue&type=script&lang=js&"
import style0 from "./NetworkCard.vue?vue&type=style&index=0&id=655b806c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655b806c",
  null
  
)

component.options.__file = "NetworkCard.vue"
export default component.exports